import { render, staticRenderFns } from "./InsuranceBillingComponent.vue?vue&type=template&id=18717fa0&scoped=true"
import script from "./InsuranceBillingComponent.vue?vue&type=script&lang=ts"
export * from "./InsuranceBillingComponent.vue?vue&type=script&lang=ts"
import style0 from "./InsuranceBillingComponent.vue?vue&type=style&index=0&id=18717fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18717fa0",
  null
  
)

export default component.exports